import {
    SALEORDER_UPDATE_PRODUCT,
    SALEORDER_UPDATE_PROJECT,
    SALEORDER_UPDATE_CUSTOMER,
    SALEORDER_UPDATE_YEARSPAYMENT,
    SALEORDER_UPDATE_CAMPAIGN,
    SALEORDER_UPDATE_INITIAL_QUOTA,
    SALEORDER_UPDATE_PAYMENTCONDITION,
    SALEORDER_NEGOTIATE,
    SHOW_ERROR_MESSAGE,
    SALEORDER_CLEAN_NEGOTIATE,
    SALEORDER_UPDATE_SPOTTREESELECTION,
    SALEORDER_SUCCESSFUL_POST,
    SALEORDER_CLEAN_STATE,
    SALEORDER_SUCCESSFUL_GET,
    SALEORDER_SUCCESSFUL_UPDATE_PRODUCT,
    SALEORDER_SUCCESSFUL_UPDATE_NEGOTIATION,
    SECOND_SALEORDER_QUALIFICATION_SUCCESSFUL_GET,
} from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient"

export const updateProduct = (product) => dispatch => {
    console.log("product", product);
    dispatch(
        {
            type: SALEORDER_UPDATE_PRODUCT,
            payload: product
        }
    )
}

export const updateProject = (project) => dispatch => {
    console.log("project", project);
    dispatch(
        {
            type: SALEORDER_UPDATE_PROJECT,
            payload: project
        }
    )
}

export const updateCustomer = (customer) => dispatch => {
    dispatch(
        {
            type: SALEORDER_UPDATE_CUSTOMER,
            payload: customer
        }
    )
}

export const updateYearsPayment = (yearsPayment) => dispatch => {
    dispatch(
        {
            type: SALEORDER_UPDATE_YEARSPAYMENT,
            payload: yearsPayment
        }
    )
}

export const updateCampaign = (campaign) => dispatch => {
    dispatch(
        {
            type: SALEORDER_UPDATE_CAMPAIGN,
            payload: campaign
        }
    )
}

export const updateInitialQuota = (initialQuota) => dispatch => {
    dispatch(
        {
            type: SALEORDER_UPDATE_INITIAL_QUOTA,
            payload: initialQuota
        }
    )
}

export const updatePaymentCondition = (paymentCondition) => dispatch => {
    dispatch(
        {
            type: SALEORDER_UPDATE_PAYMENTCONDITION,
            payload: paymentCondition
        }
    )
}

export const negotiateSaleOrder = (customer, product, paymentCondition, yearsPayment, campaign, initialQuotaAmount) => dispatch => {
    const saleOrderNegotiationDto = {
        customerId: customer ? customer.id : null,
        productId: product.id,
        paymentConditionsType: paymentCondition,
        yearsPayment: yearsPayment,
        campaignId : campaign,
        initialQuota : initialQuotaAmount
    }
    let pathSecondSaleOrder = customer ? "" : "/secondsaleorgreater";
    new HttpClient(true).post("oga/saleorder/negotiate" + pathSecondSaleOrder, saleOrderNegotiationDto)
        .then((response) => {
            dispatch({
                type: SALEORDER_NEGOTIATE,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });
        })
}

export const cleanNegotiate = () => dispatch => {
    dispatch(
        {
            type: SALEORDER_CLEAN_NEGOTIATE,
            payload: ""
        }
    )
}

export const updateSpotTreeSelection = (nodeId) => dispatch => {
    dispatch(
        {
            type: SALEORDER_UPDATE_SPOTTREESELECTION,
            payload: nodeId
        }
    )
}

export const saveSaleOrder = (saleOrderDto, resolve, reject) => dispatch => {
    let secondSalePath = !saleOrderDto.customerId && !saleOrderDto.nodeIdSelected ? "/secondsaleorgreater" : "";
    new HttpClient(true).post("oga/saleorder" + secondSalePath, saleOrderDto)
        .then((response) => {
            dispatch({
                type: SALEORDER_SUCCESSFUL_POST,
                payload: response.data
            });
            resolve("Successful");
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });
            reject("Failed");
        })
}

export const cleanSaleOrder = () => dispatch => {
    dispatch({
        type: SALEORDER_CLEAN_STATE,
        payload: {}
    });
}


export const fetchSaleOrder = (saleOrderId) => dispatch => {
    new HttpClient(true).get("oga/saleorder",
        {
            params: {
                saleOrderId: saleOrderId
            }
        })
        .then((response) => {
            dispatch({
                type: SALEORDER_SUCCESSFUL_GET,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        });
}


export const updateProductSaleOrder = (saleOrderId, productId, resolve, reject) => dispatch => {
    new HttpClient(true).post("oga/saleorder/product?saleOrderId=" + saleOrderId + "&productId=" + productId)
        .then((response) => {
            dispatch({
                type: SALEORDER_SUCCESSFUL_UPDATE_PRODUCT,
                payload: response.data
            });
            resolve("Successful");
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });
            reject("Failed");
        })
}

export const updateNegotiationSaleOrder = (saleOrderId, customer, product,
    paymentCondition, yearsPayment, campaign, resolve, reject) => dispatch => {
        const saleOrderNegotiationDto = {
            customerId: customer.id,
            productId: product.id,
            paymentConditionsType: paymentCondition,
            yearsPayment: yearsPayment,
            campaignId : campaign
        }

        new HttpClient(true).post("oga/saleorder/negotiation?saleOrderId=" + saleOrderId,
            saleOrderNegotiationDto)
            .then((response) => {
                dispatch({
                    type: SALEORDER_SUCCESSFUL_UPDATE_NEGOTIATION,
                    payload: response.data
                });
                resolve("Successful");
            })
            .catch((error) => {
                dispatch({
                    type: SHOW_ERROR_MESSAGE,
                    payload: error.response.data.message
                });
                reject("Failed");
            })
    }

export const fetchSecondSaleOrderQualification = (saleOrderId) => dispatch => {
    new HttpClient(true).get("oga/saleorder/secondsaleorgreater",
        {
            params: {}
        })
        .then((response) => {
            dispatch({
                type: SECOND_SALEORDER_QUALIFICATION_SUCCESSFUL_GET,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        });
}


// WEBPACK FOOTER //
// ./src/reducers/saleorder/saleorderActions.js